import { Centered } from '@cof/omni-react';
import { PrimaryHeader } from '@components/global';
import { Box, CTA } from '@components/global';
import { useWorkflow } from '@hooks/useWorkflow';

interface EnrollmentsResponse {
  cardImage: string;
  cardImageAlt: string;
  cardType: string;
  last4: string;
  walletName: string;
}

export const Enrollments = () => {
  const { templateJson, reqUrl, error } = useWorkflow();
  const { cardImage, cardImageAlt, cardType, last4, walletName } =
    templateJson as EnrollmentsResponse;

  if (error) {
    console.log(error);
  }

  return (
    <div data-testid="Enrollments">
      <PrimaryHeader>Would you like to add this card?</PrimaryHeader>
      <Centered>
        <img
          style={{ margin: '30px', width: '80%' }}
          src={`${reqUrl}${cardImage}`}
          alt={cardImageAlt}
        />
      </Centered>
      <Box>
        <h3
          style={{ textAlign: 'center', fontSize: '1em' }}
        >{`Do you want to add your ${cardType} card ending in ${last4} to ${walletName}?`}</h3>
      </Box>
      <CTA
        primaryText="Yes, continue"
        primaryCallback={() => {
          console.log('yes clicked');
        }}
        secondaryText="No, I don't recognize this."
        secondaryCallback={() => {
          console.log('no clicked');
        }}
      />
    </div>
  );
};
